import axios from "axios";
//https://vip-backend-otk4.onrender.com
//https://vip.serveo.net/https://vip.serveo.net
const baseUrl = axios.create({
  baseURL: "https://vip-website.onrender.com",     
});   
 
export const baseUrlImg = "https://vip-website.onrender.com";
export default baseUrl;
 